import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./components/registration-wizard/registration-wizard.component').then(m => m.RegistrationWizardComponent)
  },
  {
    path: 'signup/payment-return',
    loadComponent: () => import('./components/payment-return/payment-return.component').then(m => m.PaymentReturnComponent)
  },
  {
    path: 'signin',
    loadComponent: () => import('./components/sign-in/sign-in.component').then(m => m.SignInComponent)
  },
  {
    path: 'features/data-profiler',
    loadComponent: () => import('./components/features/data-profiler.component').then(m => m.DataProfilerComponent)
  },
  {
    path: 'features/ai-readiness',
    loadComponent: () => import('./components/features/ai-readiness.component').then(m => m.AiReadinessComponent)
  },
  {
    path: 'features/anomaly-detection',
    loadComponent: () => import('./components/features/anomaly-detection.component').then(m => m.AnomalyDetectionComponent)
  },
  {
    path: 'features/clean-data',
    loadComponent: () => import('./components/features/clean-data.component').then(m => m.CleanDataComponent)
  },
  {
    path: 'features/compare',
    loadComponent: () => import('./components/features/feature-comparison.component').then(m => m.FeatureComparisonComponent)
  },
  {
    path: 'user-data-protection',
    loadComponent: () => import('./components/static/user-data-protection.component').then(m => m.UserDataProtectionComponent)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./components/static/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'cookie-policy',
    loadComponent: () => import('./components/static/cookie-policy.component').then(m => m.CookiePolicyComponent)
  },
  {
    path: 'data-processing-agreement',
    loadComponent: () => import('./components/static/data-processing-policy.component').then(m => m.DataProcessingPolicyComponent)
  },
  {
    path: 'support',
    loadComponent: () => import('./components/static/support.component').then(m => m.SupportComponent)
  },
  {
    path: 'plans',
    loadComponent: () => import('./components/plans/plans-page.component').then(m => m.PlansPageComponent)
  },
  {
    path: 'contact-sales',
    loadComponent: () => import('./components/contact-sales').then(m => m.ContactSalesComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
